<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="ButtonComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-ButtonComponent'>
        <img v-show="internal_config.multipleActions.length == 0" src="static/images/icons/link.svg"
                           v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
                           class="svg-icon normal-action"
                           @click="linkElement"/>
        <img src="static/images/icons/multiple-actions.svg"
                           v-tooltip="{content:$t('ct-multiple-actions'),  class: 'tooltip-custom'}"
                           class="svg-icon normal-action"
                           @click="multipleActions($event)"/>
      </options-element-bar>
      <div
        v-bind:style="{height : height,width : width,border : border,'border-radius': radius,background: background,'box-shadow': boxShadow,}"
        class="bt-sb desktop-element">
          <a class="sb-text" :style="textStyle()">{{internal_config.text}}</a>
          <small class="sb-sub-text" v-show="this.internal_config.subtext"
                 :style="subTextStyle()">{{internal_config.subtext}}</small>
      </div>
      <div
        v-bind:style="{height : height,width : width,border : border,'border-radius': radius,background: background,'box-shadow': boxShadow,}"
        class="bt-sb mobile-element">
        <a class="sb-text" :style="textStyleMobile()">{{internal_config.text}}</a>
        <small class="sb-sub-text" v-show="this.internal_config.subtext"
                :style="subTextStyleMobile()">{{internal_config.subtext}}</small>
      </div>

      <resources ref="resourcesData"></resources>

    </vue-draggable-resizable>

  </div>
</template>

<script>

import Data from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from "../OptionsElementBar";

export default {
  name: 'ButtonComponent',
  props: ['config', 'id', 'preview'],
  components: {
    OptionsElementBar,
    Resources
  },
  computed: {
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    border() {
      return this.internal_config.border;
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    background() {
      let bg = this.internal_config.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
        bg += ' url("' + this.internal_config.backgroundImage + '")';
        bg += ' ' + this.internal_config.backgroundPosition;
        bg += ' / ' + this.internal_config.backgroundSize;
        bg += ' ' + this.internal_config.backgroundRepeat;
        bg += ' ' + this.internal_config.backgroundOrigin;
      }

      return bg;
    }
  },
  data() {
    return Data.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },

  methods: {

    animation() {
      return true;
    },

    linkElement: function() {
      this.$root.$emit('linkComponentShow', this);
    },

    multipleActions(event) {

      let obj = {
        actions: this.internal_config.multipleActions,
        rotator: this.internal_config.multipleActionsRotator
      }

      this.$root.$emit('showButtonMultipleActions', event,
      obj, (actions, rotator) => {
        this.internal_config.multipleActions = actions;
        this.internal_config.multipleActionsRotator = rotator;
      });
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);
      this.$root.$emit('showResourceRightSideBar', 'backgroundColorHover', this.internal_config.hover);
      this.$root.$emit('showResourceRightSideBar', 'textColorHover', this.internal_config.hover);

      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    deleteImage() {
      this.$emit('delete', {});
    },
    edit(e) {
      e.preventDefault();
      this.internal_config.src = prompt('src', this.internal_config.src);
    },
    buildIcon: function() {
      $(this.$el).find('i').detach();

      if (this.internal_config.icon !== '') {
        if (this.internal_config.iconPosition === 'left') {
          $('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.sb-text').get(0));
          $('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.sb-text').get(1));
        }
        if (this.internal_config.iconPosition === 'right') {
          $('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.sb-text').get(0));
          $('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.sb-text').get(1));
        }
      }
    },
    build(config) {
      this.internal_config = config;
    },
    rebuild() {
      let vm = this;
      let config = this.internal_config;
      this.internal_config = {};
      this.$nextTick(() => {
        vm.internal_config = config;
        vm.buildIcon();
      });
    },
    textStyle() {
      return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.size};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 text-decoration: ${this.internal_config.textStyle.stroke};
                 color: ${this.internal_config.textStyle.color}`;
    },
    subTextStyle() {
      return `font-family:  ${this.internal_config.subTextStyle.family};
                 font-size: ${this.internal_config.subTextStyle.size};
                 text-align: ${this.internal_config.subTextStyle.align};
                 font-weight: ${this.internal_config.subTextStyle.weight};
                 font-style: ${this.internal_config.subTextStyle.style};
                 text-decoration: ${this.internal_config.subTextStyle.stroke};
                 color: ${this.internal_config.subTextStyle.color}`;
    },
    textStyleMobile() {
      return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.sizeMobile};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 text-decoration: ${this.internal_config.textStyle.stroke};
                 color: ${this.internal_config.textStyle.color}`;
    },
    subTextStyleMobile() {
      return `font-family:  ${this.internal_config.subTextStyle.family};
                 font-size: ${this.internal_config.subTextStyle.sizeMobile};
                 text-align: ${this.internal_config.subTextStyle.align};
                 font-weight: ${this.internal_config.subTextStyle.weight};
                 font-style: ${this.internal_config.subTextStyle.style};
                 text-decoration: ${this.internal_config.subTextStyle.stroke};
                 color: ${this.internal_config.subTextStyle.color}`;
    },
    style() {
      return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top};
                cursor: ${this.internal_config.cursorType}`;;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      this.$root.$emit('showResourceRightSideBar', 'backgroundColorHover', this.internal_config.hover);
      this.$root.$emit('showResourceRightSideBar', 'textColorHover', this.internal_config.hover);
      e.stopPropagation();
      e.preventDefault();
    },
  },
  created() {
    this.build(this.$props.config);

    this.internal_config = window.mergeRecursive(this.props, this.$props.config);
  },
  mounted() {
    this.buildIcon();

    let objIds = [];
    $('[id][element]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) { objIds.push(this.id) }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if(this.id == id){
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$refs.resourcesData.setValuesData(this);
  },

  updated() {

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

      this.$el.classList.add('preview');

      if (this.internal_config.hover) {
        let vm = this;
        let button = $('#' + this.id + ' div.bt-sb');

        $(this.$el).hover(function() {
          button.css('background', vm.internal_config.backgroundColorHover);
          button.find('.btn').css('color', vm.internal_config.textColorHover);
        }, function() {
          button.css('background', vm.background);
          button.find('.btn').css('color', vm.internal_config.textStyle.color);
        });
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .vdr, .bt-sb {
    display: grid;
    align-content: center;
    /*height: auto !important;*/
  }

  .preview .bt-sb:hover {
    cursor: pointer;
  }

  .bt-text-area {
    /*display: grid;*/
    /*height: auto !important;*/

    .btn {
      padding: 0 !important;
    }

  }
</style>
<style lang="scss">

  [data-device="mobile"] [element="ButtonComponent"] .bt-text-area {
    max-width: 300px !important;
    width: 300px !important;
  }
  [data-device="tablet"] [element="ButtonComponent"] .bt-text-area {
    max-width: 768px !important;
    width: 768px !important;
  }

  [element="ButtonComponent"]{
    @media (max-width: 800px) {
      .bt-text-area {
        max-width: 300px !important;
        width: 300px !important;
      }
    }
  }

  @media (max-width: 800px) {
    .bt-text-area {
      max-width: 300px !important;
      width: 100% !important;
    }
  }

  [data-device="mobile"] .bt-text-area {
    max-width: 300px !important;
    width: 300px !important;
      /*width: 100% !important;*/
  }
  [data-device="tablet"] .bt-text-area {
    max-width: 768px !important;
    width: 768px !important;
  }

  .bt-sb {
    margin: 0 auto;
  }

  .bt-text-area {
    .sb-sub-text,
    .sb-text {
      width: 100%;
    }

    .top,
    .bottom {
      width: 100%;
      display: block;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Button/Button.vue